const Footer = () => {
  return (
    <div className="footer">
      <span>
        Made with Love by{" "}
        <a href="https://github.com/akpamaboris">Akpama Boris</a>
      </span>
    </div>
  );
};

export default Footer;
